export default "__VITE_ASSET__CxBISPKd__"